import Vue from 'vue';
import { Route } from 'vue-router';
import { appConfig } from '@/config/app.config';
import { Address } from '@/app/domain/webservice-dto';

const routeMapping: any = {
    'ConstructionTypesStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/1',
        virtualPageName: 'Bauversicherung - 1',
    },
    'WhereStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/2',
        virtualPageName: 'Bauversicherung - 2',
    },
    'WhenStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/3',
        virtualPageName: 'Bauversicherung - 3',
    },
    'SumStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/4',
        virtualPageName: 'Bauversicherung - 4',
    },
    'RisksStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/5',
        virtualPageName: 'Bauversicherung - 5',
    },
    'MatrixStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/6',
        virtualPageName: 'Bauversicherung - 6',
    },
    'ContactStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/start/7',
        virtualPageName: 'Bauversicherung - 7',
    },
    'SummaryStep': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/summary',
        virtualPageName: 'Bauversicherung - summary',
    },
    'Success': {
        virtualPageUrl: 'versichern/wohneneigentum/bauversicherung/praemie-berechnen/page/internal/success',
        virtualPageName: 'Bauversicherung - success',
    },
};

export enum ClickEvent {
    ECO = 'eco',
    SMART = 'smart',
    TOP = 'top',
}

const calculator: any = {
    event: 'calculator',
    calculatorName: 'Bauversicherung',
};

export const sendEcommerceBeginEvent = (offeringLevel: string, premium: string) => {
    googleAnalyticsSendEvent({
        event: 'ecommerceBegin',
        itemName: 'Baloise Bauversicherung',
        itemPrice: premium,
        itemVariant: offeringLevel,
    });
};

export const sendEcommercePurchaseEvent = (offeringLevel: string, premium: string | undefined) => {
    googleAnalyticsSendEvent({
        event: 'ecommercePurchase',
        itemName: 'Baloise Bauversicherung',
        itemPrice: premium,
        itemVariant: offeringLevel,
    });
};

export const sendPageChangeEvent = (route: Route) => {
    if (route && routeMapping[route.name as string]) {
        googleAnalyticsSendEvent({
            event: 'virtualPageView',
            ...routeMapping[route.name as string] as any,
        });

        if (route.name === 'ConstructionTypesStep') {
            googleAnalyticsSendEvent({
                ...calculator,
                calculatorStep: 'start',
                calculatorStepName: 'Bautyp wählen',
            });
        }
    }
};

export const sendSuccessPageEvent = (insuranceTakerAddress: Address | undefined) => {
    googleAnalyticsSendEvent({
        ...calculator,
        calculatorStep: 'success',
        calculatorStepName: 'complete',
        address: {
            region: insuranceTakerAddress? insuranceTakerAddress.canton : '',
            postal_code: insuranceTakerAddress? insuranceTakerAddress.zipCode : '',
            country: insuranceTakerAddress? insuranceTakerAddress.country : '',
            city: insuranceTakerAddress? insuranceTakerAddress.city : '',
        },
    });
};

export const sendPageInformationEvent = (language: string, referrerportal: string, route: Route) => {
    if (route && routeMapping[route.name as string]) {
        if (route.name === 'ConstructionTypesStep') {
            const applicationNameValue: string = 'construction insurance '
                                                    .concat(
                                                        (referrerportal === 'enterprise' || referrerportal === 'private')
                                                            ? referrerportal : 'others',
                                                    );
            googleAnalyticsSendEvent({
                event: 'pageInformation',
                applicationLanguage: language,
                applicationName: applicationNameValue,
                applicationEnvironment: appConfig.env === 'production' || appConfig.env === 'prod' ? 'PROD Public' : 'NON PROD',
                applicationCountry: 'CH',
                pageName: 'Bauversicherung',
                pageBaseName: 'Bauversicherung',
                pageLevel: '2',
                pageType: 'content',
                pageCategoryLevelOne: 'construction-insurance',
                userLoginStatus: 'no',
            });
        }
    }
};

function googleAnalyticsSendEvent(event: any) {
    const log = Vue.$createLogger('GoogleAnalytics');
    if ((window as any).dataLayer) {
        log.info(`Send event (${event.event}) to Google Analytics`);
        (window as any).dataLayer.push(event);
    } else {
        log.info(`Could not send event (${event.event}) to Google Analytics`);
    }
}
